import React from 'react';
import {
	InstructionsWrapper,
	InstructionHeader,
	InstructionList,
	Instruction,
	BoldText,
} from './Instructions.styles';

const Instructions = ({ headerText, instructions }) => {
	const renderWithBold = str => {
		const parts = str.split('*');

		return parts.map((part, index) => {
			if (index % 2 !== 0) {
				return <BoldText key={index}>{part}</BoldText>;
			}
			return part;
		});
	};

	return (
		<React.Fragment>
			<InstructionsWrapper>
				<InstructionHeader>{headerText}:</InstructionHeader>
				<InstructionList>
					{instructions.map((instr, index) => (
						<Instruction key={index}>{renderWithBold(instr)}</Instruction>
					))}
				</InstructionList>
			</InstructionsWrapper>
		</React.Fragment>
	);
};

export default Instructions;
